import React from "react";
import Footer from "../footer/Footer";
import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";

const images = [
  {
    original: require("../../assets/image1.jpeg"),
    thumbnail: require("../../assets/image1.jpeg"),
  }
];

const Gallary = () => {
  return (
    <div>
      <div className="gallary">
        <div>
          <p style={{ color: "#00387b", fontSize: 30, fontWeight: "bold" }}>
ESNAD Gallarie          </p>
        </div>
        <div>
          <ImageGallery layout="columns" items={images} />
        </div>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Gallary;
